import styles from "./VerticalAnimatedLine.module.css";

export function VerticalAnimatedLine() {
  return <div className={styles.verticalAnimatedLine} />;
}
